/**
 * Logo do Degrau (guarda-chuva): três degraus que sobem com um broto no topo —
 * crescimento em degraus. Mesma arte do favicon (public/favicon.svg); manter em
 * sincronia se alterar. Escala pelo viewBox; aceita `size` (px).
 */
export function Logo({ size = 40 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      role="img"
      aria-label="Degrau"
    >
      <rect width="512" height="512" rx="112" fill="#e3f0ec" />
      <rect x="98" y="300" width="100" height="112" rx="16" fill="#6fb3a1" />
      <rect x="198" y="246" width="100" height="166" rx="16" fill="#3f8f7c" />
      <rect x="298" y="192" width="100" height="220" rx="16" fill="#2f7565" />
      <path
        d="M348 196 C343 170 343 158 348 130"
        fill="none"
        stroke="#2f7565"
        strokeWidth="22"
        strokeLinecap="round"
      />
      <ellipse cx="312" cy="140" rx="42" ry="24" fill="#3f8f7c" transform="rotate(-34 312 140)" />
      <ellipse cx="384" cy="124" rx="42" ry="24" fill="#6fb3a1" transform="rotate(34 384 124)" />
    </svg>
  );
}
